import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const InformationModalPlan = (props: any) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={props.showModal}
      onHide={props.handleContinue}
      className="custom-modal-uniform  uniformModel"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-center w-100">
          {t("uniform_survey.your_uniform.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="uniform-survey-info mb-1 mt-1">
          <table className="table table table-bordered">
            <thead style={{ backgroundColor: "#635c8a", color: "#ffff" }}>
              <tr>
                <th scope="col">
                  {t("uniform_survey.your_uniform.infoUniform.set1")}
                </th>
                <th scope="col">
                  {t("uniform_survey.your_uniform.infoUniform.set3")}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {props.benefit?.choices[0].shirtQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src={`../images/uniformtype/${props.benefit?.shirtType.replace(
                              " ",
                              "-"
                            )}.jpg`}
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.shirtDescriptionEn
                              : props.benefit?.shirtDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[0].shirtQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}

              {props.benefit?.choices[1].shirtQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src={`../images/uniformtype/${props.benefit?.shirtType.replace(
                              " ",
                              "-"
                            )}.jpg`}
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.shirtDescriptionEn
                              : props.benefit?.shirtDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[1].shirtQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}
              </tr>


              <tr>
                {props.benefit?.choices[0].pantsQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/pants.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.pantsDescriptionEn
                              : props.benefit?.pantsDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[0].pantsQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}

                {props.benefit?.choices[1].pantsQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/pants.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.pantsDescriptionEn
                              : props.benefit?.pantsDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[1].pantsQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}
              </tr>

              <tr>
                {props.benefit?.choices[0].dressQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/dress.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.dressDescriptionEn
                              : props.benefit?.dressDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[0].dressQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}

                {props.benefit?.choices[1].dressQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/dress.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.dressDescriptionEn
                              : props.benefit?.dressDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[1].dressQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}
              </tr>

              <tr>
                {props.benefit?.choices[0].braQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/bras.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.braDescriptionEn
                              : props.benefit?.braDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[0].braQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}

                {props.benefit?.choices[1].braQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/bras.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.braDescriptionEn
                              : props.benefit?.braDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[1].braQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}
              </tr>

              <tr>
                {props.benefit?.choices[0].slipperQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/slippers.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.slipperDescriptionEn
                              : props.benefit?.slipperDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[0].slipperQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}

                {props.benefit?.choices[1].slipperQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/slippers.png"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.slipperDescriptionEn
                              : props.benefit?.slipperDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[1].slipperQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <></>
                )}
              </tr>

              <tr>
                {props.benefit?.choices[0].tumblerQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/tumbler.png?a1"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.tumblerDescriptionEn
                              : props.benefit?.tumblerDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[0].tumblerQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <td></td>
                )}

                {props.benefit?.choices[1].tumblerQty > 0 ? (
                  <td>
                    <Container className="">
                      <Row>
                        <Col xs={4} className="m-0 p-0">
                          <img
                            src="../images/uniform/tumbler.png?a1"
                            alt="UniformSurvey"
                            width={50}
                            className="rounded border"
                          />
                        </Col>
                        <Col xs={8}>
                          <div className="list-title">
                            {localStorage.getItem("Language") === "en"
                              ? props.benefit?.tumblerDescriptionEn
                              : props.benefit?.tumblerDescriptionTh}
                          </div>
                          <div className="list-size">
                            {t("uniform_survey.your_uniform.amount")}:{" "}
                            {props.benefit?.choices[1].tumblerQty}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </td>
                ) : (
                  <td></td>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};
